import React, { useState, useEffect } from "react";
import "./nav.css";

const Nav = ({
  page,
  setPage,
  emulatorStep,
  setEmulatorStep,
  setCurrentScreen,
  resized,
}) => {
  const [toggleNav, setToggleNav] = useState(null);
  const [activeLink, setActiveLink] = useState(false);
  const [isTouch, setIsTouch] = useState(
    window.matchMedia("(pointer: coarse)").matches
  );

  // const [selected, setSelected] = useState("webOS-home-ov");
  const sleep = async (interval) => {
    await new Promise((r) => setTimeout(r, interval));
    setToggleNav(false);
    setActiveLink(false);
  };

  const [slides, setSlides] = useState(null);
  const [playing, setPlaying] = useState(false);

  const runSlideShow = () => {
    let counter = 0;
    let timeBetween = 6000;
    if (slides) {
      clearInterval(slides);
      setSlides(null);
      setPlaying(false);
    } else {
      setPlaying(true);
      setPage("web-os-tv-home");
      setSlides(
        setInterval(function () {
          if (counter >= 79) {
            clearInterval(slides);
            setSlides(null);
            setPlaying(false);
          } else {
            // console.log(document.getElementById("real-next-arrow"));
            if (document.getElementById("real-next-arrow")) {
              document.getElementById("real-next-arrow").click();
            } else {
              setEmulatorStep((prevState) => {
                prevState++;
                return prevState;
              });
            }
            counter++;
          }
        }, timeBetween)
      );
    }
  };

  useEffect(() => {
    if (page === "Emulator" || page === "home") {
      setPlaying(false);
      clearInterval(slides);
      setSlides(null);
    }
    if (toggleNav) {
      setToggleNav(false);
    }
  }, [page]);
  return (
    <div
      className={
        // page === "magic_remote"
        //   ? toggleNav === true
        //     ? `sidenav sidenav-remote slideOut`
        //     : toggleNav === false
        //     ? `sidenav sidenav-remote backIn`
        //     : `sidenav-remote sidenav`
        //   :
        toggleNav === true
          ? `sidenav slideOut`
          : toggleNav === false
          ? `sidenav backIn`
          : `sidenav`
      }
      style={{ animationDelay: resized ? "0.5s" : "8.5s" }}
      onMouseEnter={() => {
        if ((toggleNav === false || toggleNav === null) && !isTouch) {
          setToggleNav(true);
          setTimeout(() => {
            setActiveLink(true);
          }, 800);
        }
      }}
      onMouseLeave={() => {
        if (toggleNav === true && !isTouch) {
          setToggleNav(false);
          setTimeout(() => {
            setActiveLink(false);
          }, 800);
        }
      }}
      onClick={() => {
        if ((toggleNav === false || toggleNav === null) && isTouch) {
          setToggleNav(true);
          setTimeout(() => {
            setActiveLink(true);
          }, 800);
        }
      }}
      // style={{
      //   backgroundColor:
      //     page === "magic_remote"
      //       ? "rgba(255,255,255,0.15)"
      //       : "rgba(0,0,0, 0.85)",
      // }}
      id="nav-drawer"
    >
      <div className="icon-container">
        {toggleNav === null || toggleNav === false ? (
          <img
            src="./images/menu.svg"
            className="menu-icon"
            onClick={() => {
              setToggleNav(true);
              setTimeout(() => {
                setActiveLink(true);
              }, 800);
            }}
            alt="Menu burger icon"
          />
        ) : (
          <img
            src="./images/close.svg"
            className="menu-icon"
            onClick={() => {
              document.getElementById("nav-drawer").style.pointerEvents =
                "none";
              setToggleNav(false);
              setTimeout(() => {
                document.getElementById("nav-drawer").style.pointerEvents =
                  "all";
                setActiveLink(false);
              }, 800);
            }}
            alt="Menu close icon"
          />
        )}
      </div>
      <div
        className={
          toggleNav === true
            ? `textOut`
            : toggleNav === false
            ? `textIn`
            : resized
            ? "textalt"
            : `text`
        }
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          pointerEvents: toggleNav === true ? "all" : "none",
        }}
      >
        <div>
          <div className="section" style={{ marginBottom: "0px" }}>
            <h3>Overview</h3>
            <ul>
              <li
                id="tv"
                className={page === "home" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("home");
                  }
                }}
              >
                webOS TV Home
              </li>
              <li
                id="remote"
                className={page === "magic_remote" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("magic_remote");
                  }
                }}
              >
                Magic Remote
              </li>
            </ul>
          </div>
          <div className="work">
            <div className="bar" style={{ margin: " 0 0 8px 0" }}></div>
            <div
              className="section emulator"
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (activeLink === true) {
                  setPage("Emulator");
                }
                setCurrentScreen("images/screens/001.jpg");
              }}
            >
              <h3
                style={{ padding: "2px 0", fontSize: "28px" }}
                className={page === "Emulator" ? "selected" : ""}
              >
                Emulator
              </h3>
            </div>
            <div className="bar" style={{ margin: " 8px 0 0 0" }}></div>
          </div>
          <div
            className="section topics"
            style={
              {
                // pointerEvents: "none",
              }
            }
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <h3 style={{ fontSize: "1.5rem" }}>What is webOS TV?</h3>
              <img
                alt="play-slideshow"
                onClick={() => {
                  runSlideShow();
                }}
                style={{
                  height: "22px",
                  width: "22px",
                  marginLeft: "7px",
                  marginTop: ".75rem",
                  cursor: "pointer",
                }}
                src={playing ? "./images/stop.png" : "./images/play.png"}
              />
            </div>

            <ul>
              {/* <li
                className={page === "web-os-advantages" ? "selected" : ""}
                style={{
                  paddingTop: "4px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setPage("web-os-advantages");
                }}
              >
                webOS TV Advantages
              </li> */}
              <li
                className={page === "web-os-tv-home" ? "selected" : ""}
                onClick={() => {
                  setPage("web-os-tv-home");
                }}
              >
                Intuitive Home and Rich Contents
              </li>
              {/* <li
                className={page === "RCP" ? "selected" : ""}
                onClick={() => {
                  setPage("RCP");
                }}
              >
                Rich Content Provider (RCP)
              </li> */}
              <li
                className={page === "various-contents" ? "selected" : ""}
                onClick={() => {
                  setPage("various-contents");
                }}
              >
                Various Contents
              </li>
              <li
                className={page === "cloud-gaming-service" ? "selected" : ""}
                onClick={() => {
                  setPage("cloud-gaming-service");
                }}
              >
                Cloud Gaming Service
              </li>
              <li
                className={page === "lg-channels" ? "selected" : ""}
                onClick={() => {
                  setPage("lg-channels");
                }}
              >
                LG Channels
              </li>
              <li
                className={page === "ai-recs" ? "selected" : ""}
                onClick={() => {
                  setPage("ai-recs");
                }}
              >
                AI Recommendation
              </li>
              <li
                className={page === "EPG" ? "selected" : ""}
                onClick={() => {
                  setPage("EPG");
                }}
              >
                EPG (Electronic Program Guide)
              </li>
              <li
                className={
                  page === "magic-remote-home" ||
                  page === "ai-voice-magic-remote" ||
                  page === "overview-magic-remote" ||
                  page === "quick-access-magic-remote"
                    ? "selected"
                    : ""
                }
                onClick={() => {
                  if (activeLink === true) {
                    setPage("overview-magic-remote");
                    sleep();
                  }
                }}
              >
                Magic Remote
              </li>
              <ul
                style={{
                  marginLeft: "24px",
                  marginTop: "-12px",
                  padding: "2px 0 1px 0",
                }}
              >
                <li
                  // style={{
                  //   pointerEvents: "none",
                  // }}
                  className={page === "overview-magic-remote" ? "selected" : ""}
                  onClick={() => {
                    if (activeLink === true) {
                      setPage("overview-magic-remote");
                      sleep();
                    }
                  }}
                >
                  Overview
                </li>
                <li
                  // style={{
                  //   pointerEvents: "none",
                  // }}
                  className={
                    page === "direct-access-magic-remote" ? "selected" : ""
                  }
                  onClick={() => {
                    if (activeLink === true) {
                      setPage("direct-access-magic-remote");
                    }
                  }}
                >
                  Direct Access
                </li>
                <li
                  // style={{
                  //   pointerEvents: "none",
                  // }}
                  className={
                    page === "quick-access-magic-remote" ? "selected" : ""
                  }
                  onClick={() => {
                    if (activeLink === true) {
                      setPage("quick-access-magic-remote");
                    }
                  }}
                >
                  Quick Access
                </li>
                <li
                  // style={{
                  //   pointerEvents: "none",
                  // }}
                  className={page === "ai-voice-magic-remote" ? "selected" : ""}
                  onClick={() => {
                    if (activeLink === true) {
                      setPage("ai-voice-magic-remote");
                      sleep();
                    }
                  }}
                >
                  AI/Voice
                </li>
                <li
                  // style={{
                  //   pointerEvents: "none",
                  // }}
                  className={page === "magic-explorer" ? "selected" : ""}
                  onClick={() => {
                    if (activeLink === true) {
                      setPage("magic-explorer");
                      sleep();
                    }
                  }}
                >
                  Magic Explorer
                </li>
                <li
                  // style={{
                  //   pointerEvents: "none",
                  // }}
                  className={page === "netflix-vui" ? "selected" : ""}
                  onClick={() => {
                    if (activeLink === true) {
                      setPage("netflix-vui");
                      sleep();
                    }
                  }}
                >
                  Netflix VUI
                </li>
              </ul>
              <li
                className={page === "uei" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("uei");
                    sleep();
                  }
                }}
              >
                Quickset
              </li>
              <li
                className={page === "iot" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("iot");
                    sleep();
                  }
                }}
              >
                Home Dashboard (IoT)
              </li>
              <li
                className={page === "thinkq-app" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("thinkq-app");
                    sleep();
                  }
                }}
              >
                ThinQ App
              </li>
              <li
                className={page === "media-player" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("media-player");
                    sleep();
                  }
                }}
              >
                Media Player
              </li>
              <li
                className={page === "realtek" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("realtek");
                    sleep();
                  }
                }}
              >
                REALTEK (SoC)
              </li>
              <li
                className={page === "4k-upscaler" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("4k-upscaler");
                    sleep();
                  }
                }}
              >
                4K Upscaler
              </li>
              <li
                className={page === "game-dashboard" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("game-dashboard");
                    sleep();
                  }
                }}
              >
                Game Dashboard
              </li>

              <li
                className={page === "game-optimizer" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("game-optimizer");
                    sleep();
                  }
                }}
              >
                Game Optimizer
              </li>
              <li
                className={page === "gaming" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("gaming");
                    sleep();
                  }
                }}
              >
                Gaming
              </li>
              <li
                className={page === "sound" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("sound");
                    sleep();
                  }
                }}
              >
                Sound
              </li>
              <li
                className={page === "clear-voice" ? "selected" : ""}
                onClick={() => {
                  if (activeLink === true) {
                    setPage("clear-voice");
                    sleep();
                  }
                }}
              >
                Clear Voice Pro
              </li>
            </ul>
            {/* <p
              style={{ cursor: "pointer", marginTop: "12px" }}
              className={page === "compare" ? "selected why" : "why"}
              onClick={() => {
                setPage("compare");
              }}
            >
              Why Vicarious?
            </p> */}
          </div>
          <div
            style={{
              height: "40px",
              width: "100%",
              textAlign: "center",
              letterSpacing: "0.4px",
              textOverflow: "clip",
              overflow: "hidden",
              whiteSpace: "nowrap",
              alignSelf: "flex-end",
              fontSize: "12px",
              marginTop: 0,
            }}
          >
            <p>
              {/* <a
                href="https://vicariouscontent.com/"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "rgba(0,0,0,0.9)" }}
              >
                Powered by{" "}
                <strong style={{ fontSize: "14px", color: "rgba(0,0,0,0.9)" }}>
                  VIKARIUS
                </strong>
              </a> */}
            </p>
            {/* 
            <div
            style={{
              flex: 1,
              height: "70px",
              width: "100%",
              letterSpacing: "0.4px",
              textOverflow: "clip",
              overflow: "hidden",
              whiteSpace: "nowrap",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
              marginTop: 0,
            }}
          >
            <a
              href="https://vicariouscontent.com/"
              target="_blank"
              rel="noreferrer"
              style={{
                textDecoration: "none",
              }}
            >
              <img
                src={"./images/logos/vicarious-logo.svg"}
                height="32px"
                style={{ padding: "10px 0 10px 0", marginLeft: "40px" }}
              />
            </a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nav;
